import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { BetOffer } from "@models";
import { checkIfIsMulti } from "@utils/my-bets/helpers";

export default observer(function BetOfferItemTime(props: { offer: BetOffer }) {
	const myBetsStore = useContext(MyBetsStoreContext);

	const data = checkIfIsMulti(
		props.offer,
		myBetsStore,
		"u-color--sent--danger"
	);

	return <span className={"table--bets__event__time " + data.cssClass}>{data.time}</span>;
});
